import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { adalApiFetch } from './../store/adalConfig';

const columns = [
    {
        key: 'shortCode',
        name: 'Short Code',
        editable: false
    },
    {
        key: 'departmentName',
        name: 'Department Name',
        editable: false
    },
    {
        key: 'ediCode',
        name: 'EDI Code',
        editable: false
    }
];

export default class BuyerCodeSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {    
            BuyerCode: '',  
            rows: []
        };    

        this.getBuyerCodes('');
    }

    handleStateChange = (key, value) => {
        this.setState({ ...this.state, [key]: value });
    }

    getBuyerCodes = (value) => {    
        this.setState({
            BuyerCode: value
        });

        var url = "api/lpb/GetBuyerCodes?buyerCode=" + encodeURI(value);
                
        adalApiFetch(fetch,url)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    ...this.state,
                    rows: data
                });
            });
    }

    render() {
        const { onRequestClose } = this.props;

        return (
            <Modal
                onRequestClose={onRequestClose}
                effect={Effect.Fall}>  

                <div className="container" style={{ marginTop: 20 }}>
                    <label for="BuyerCode" id="lbAvailableBuyers">Available Buyers</label>&nbsp;
                    <input id="BuyerCode" value={this.state.BuyerCode} type='text' onChange={(e) => this.getBuyerCodes(e.target.value)}></input>
                    
                    <ReactDataGrid grid
                       columns={columns}
                       rowGetter={i => this.state.rows[i]}
                       rowsCount={this.state.rows.length}
                       minHeight={300}
                       enableCellSelect={false}
                       ref={grid => this.grid = grid} />

                    <button className="btn btn-dark" onClick={ModalManager.close}>Close</button>
                </div>
            </Modal>
        );
    }
}